export const business = [
    {
        id: "content-business-latest-trends",
        name: "Latest trends",
        articles: [
            {
                id: "addec243-95e5-4aae-8261-c6b82b928293",
                class: "columns-3-wide",
                header: "Investing",
                url: "#",
                carousel: {
                    width: "684",
                    height: "385",
                    images: [
                        {
                            id: "038a6c60-3006-470b-9d93-323c1c585cf7",
                            src: "assets/images/maxim-hopman-IayKLkmz6g0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "25d59bcd-4740-48d3-921d-d4856317a848",
                            src: "assets/images/joshua-rawson-harris-KRELIShKxTM-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "58880bc6-deea-46fc-8637-02f515e81469",
                            src: "assets/images/martin-sanchez-z2v23KWm5D0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "28b22171-338a-4ada-b87e-84a7bb42c3a3",
                            src: "assets/images/nasa-1lfI7wkGWZ4-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "2587289d-eece-4001-b39e-aecfbd4a4253",
                            src: "assets/images/thomas-scott-yASysTwq-Is-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                    ],
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
            },
            {
                id: "4d5bbeee-9e05-4f95-b6bf-af41b145e4e3",
                class: "columns-3-narrow",
                header: "Media",
                url: "#",
                image: {
                    src: "assets/images/glenn-carstens-peters-npxXWgQ33ZQ-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Gravida in fermentum et sollicitudin ac. Varius duis at consectetur lorem donec massa sapien faucibus.",
                type: "text",
                content:
                    "Nisi quis eleifend quam adipiscing vitae proin. Nunc sed velit dignissim sodales ut. Turpis nunc eget lorem dolor sed. Enim nulla aliquet porttitor lacus. Consequat ac felis donec et. Aliquam sem fringilla ut morbi tincidunt augue interdum velit.",
            },
            {
                id: "a788ad50-9e3a-461e-be18-828fbce1dbd9",
                class: "columns-3-narrow",
                header: "Insights",
                url: "#",
                image: {
                    src: "assets/images/kenny-eliason-4N3iHYmqy_E-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Venenatis urna cursus eget nunc. Adipiscing elit duis tristique sollicitudin.",
                type: "text",
                content: "Donec adipiscing tristique risus nec. Vel fringilla est ullamcorper eget nulla facilisi etiam dignissim. Vitae et leo duis ut diam quam. Pulvinar etiam non quam lacus suspendisse faucibus interdum posuere lorem.",
            },
        ],
    },
    {
        id: "content-business-market-watch",
        name: "Market Watch",
        articles: [
            {
                id: "ed902471-e96d-462b-bc88-01c7e22d5fa0",
                class: "columns-3-balanced",
                header: "Trending",
                image: {
                    src: "assets/images/anne-nygard-tcJ6sJTtTWI-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Dictumst quisque sagittis purus sit amet.",
                type: "text",
                content:
                    "Dolor magna eget est lorem. Nibh sit amet commodo nulla facilisi nullam. Etiam non quam lacus suspendisse faucibus interdum. Posuere sollicitudin aliquam ultrices sagittis orci. Massa enim nec dui nunc mattis enim ut tellus. Congue mauris rhoncus aenean vel. Egestas integer eget aliquet nibh praesent tristique.",
            },
            {
                id: "31a8663a-d035-4b62-adeb-195a1c60e831",
                class: "columns-3-balanced",
                header: "Tech",
                image: {
                    src: "assets/images/truckrun-XBWF6_TEsFM-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Posuere sollicitudin aliquam ultrices sagittis orci a.",
                type: "text",
                content: "Praesent elementum facilisis leo vel fringilla est ullamcorper. Scelerisque viverra mauris in aliquam sem fringilla. Donec ac odio tempor orci. Eu augue ut lectus arcu. Diam sollicitudin tempor id eu nisl nunc mi ipsum.",
            },
            {
                id: "bf9491d2-ffcc-4ed3-a3a4-2cfda792f06b",
                class: "columns-3-balanced",
                header: "Success",
                image: {
                    src: "assets/images/alex-hudson-7AgqAZbogOQ-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Scelerisque fermentum dui faucibus in.",
                type: "text",
                content:
                    "landit volutpat maecenas volutpat blandit. Pulvinar pellentesque habitant morbi tristique senectus et. Facilisis magna etiam tempor orci. Sit amet commodo nulla facilisi nullam vehicula. Tortor vitae purus faucibus ornare suspendisse sed nisi lacus sed. Mus mauris vitae ultricies leo.",
            },
        ],
    },
    {
        id: "content-business-economy-today",
        name: "Economy Today",
        articles: [
            {
                id: "95d5859b-44d0-452b-adba-52af428c9b8e",
                class: "columns-wrap",
                header: "Global Impact",
                type: "excerpt",
                content: [
                    {
                        id: "1f074185-0c72-47cc-b889-2b0d5be855eb",
                        image: {
                            src: "assets/images/chris-leboutillier-TUJud0AWAPI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Bibendum arcu vitae elementum curabitur vitae nunc sed. Ipsum faucibus vitae aliquet nec ullamcorper sit. Blandit libero volutpat sed cras ornare arcu dui. Maecenas sed enim ut sem viverra aliquet.",
                    },
                    {
                        id: "5ba10ec7-2031-4e61-98c4-4fa2e681c0e2",
                        image: {
                            src: "assets/images/nasa-Q1p7bh3SHj8-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Arcu risus quis varius quam quisque id diam vel quam. Sed risus pretium quam vulputate dignissim suspendisse in. Amet aliquam id diam maecenas ultricies mi. Egestas dui id ornare arcu odio.",
                    },
                    {
                        id: "8534ba50-7daa-43da-ab5e-929b06ee127f",
                        image: {
                            src: "assets/images/markus-spiske-Nph1oyRsHm4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "At risus viverra adipiscing at in tellus. Morbi tempus iaculis urna id volutpat lacus laoreet non. Eu volutpat odio facilisis mauris sit amet. Leo urna molestie at elementum eu facilisis sed.",
                    },
                ],
            },
            {
                id: "f89eb533-713d-4ece-9998-c29672199357",
                class: "columns-wrap",
                header: "Outlook",
                type: "excerpt",
                content: [
                    {
                        id: "c9e71431-0407-4329-bbb3-61a820dc636a",
                        image: {
                            src: "assets/images/denys-nevozhai-z0nVqfrOqWA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ut etiam sit amet nisl purus in mollis nunc sed. Eget mauris pharetra et ultrices neque ornare aenean. Magna sit amet purus gravida quis blandit turpis.",
                    },
                    {
                        id: "d0c42c8e-e4a5-46b7-a7a7-9e3e8dfb34a3",
                        image: {
                            src: "assets/images/taylor-grote-UiVe5QvOhao-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Eu nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Viverra aliquet eget sit amet tellus cras. Consequat id porta nibh venenatis. Ac felis donec et odio pellentesque diam volutpat commodo sed.",
                    },
                    {
                        id: "c3bbf9c0-e133-405b-8a1b-e24da3258980",
                        image: {
                            src: "assets/images/linkedin-sales-solutions--AXDunSs-n4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Montes nascetur ridiculus mus mauris vitae ultricies leo integer. Habitasse platea dictumst vestibulum rhoncus est pellentesque elit.",
                    },
                ],
            },
            {
                id: "eb628ced-8e49-4cc7-a4b6-2531bc5f7b30",
                class: "columns-wrap",
                header: "Financial Freedom",
                type: "excerpt",
                content: [
                    {
                        id: "bc0da085-5ade-493d-8784-78ae2607cf29",
                        image: {
                            src: "assets/images/tierra-mallorca-rgJ1J8SDEAY-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Bibendum arcu vitae elementum curabitur vitae nunc sed. Facilisis mauris sit amet massa vitae tortor condimentum lacinia.",
                    },
                    {
                        id: "9ae84ec2-229d-4969-870a-23e8561146ef",
                        image: {
                            src: "assets/images/stephen-phillips-hostreviews-co-uk-em37kS8WJJQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ipsum nunc aliquet bibendum enim facilisis gravida neque convallis. At in tellus integer feugiat scelerisque varius morbi enim. Nisi vitae suscipit tellus mauris a.",
                    },
                    {
                        id: "8b9e5c03-b566-4e78-9df3-768698a17713",
                        image: {
                            src: "assets/images/roberto-junior-4fsCBcZt9H8-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Diam sollicitudin tempor id eu nisl nunc mi ipsum faucibus. In pellentesque massa placerat duis ultricies lacus sed.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-must-read",
        name: "Must Read",
        articles: [
            {
                id: "b77172cc-4e49-40ca-9235-eb2f5f865804",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "75dba799-f4f1-43d7-909c-81e107a61281",
                        image: {
                            src: "assets/images/carl-nenzen-loven-c-pc2mP7hTs-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Scelerisque viverra mauris in aliquam sem fringilla ut morbi. Senectus et netus et malesuada fames ac turpis egestas. Et tortor at risus viverra. Iaculis nunc sed augue lacus viverra vitae congue. Nulla aliquet porttitor lacus luctus accumsan.",
                        url: "#",
                    },
                    {
                        id: "7d882247-3db1-4882-a609-ee5eed6dc6df",
                        image: {
                            src: "assets/images/devi-puspita-amartha-yahya-7ln0pST_O8M-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Vitae justo eget magna fermentum. Vel eros donec ac odio tempor orci dapibus. Volutpat est velit egestas dui id ornare arcu odio. Est sit amet facilisis magna. Bibendum est ultricies integer quis auctor elit. Ullamcorper dignissim cras tincidunt lobortis feugiat vivamus.",
                        url: "#",
                    },
                    {
                        id: "de04fa72-d96e-4eb7-bbf7-d587e31a5f6b",
                        image: {
                            src: "assets/images/bernd-dittrich-Xk1IfNnEhRA-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Nisl tincidunt eget nullam non nisi est sit. At consectetur lorem donec massa sapien faucibus et molestie ac. Semper risus in hendrerit gravida rutrum. Eget aliquet nibh praesent tristique magna sit. Mi quis hendrerit dolor magna eget.",
                        url: "#",
                    },
                    {
                        id: "d6275634-2236-4a3c-b787-a71d33ae5bdf",
                        image: {
                            src: "assets/images/crystal-kwok-xD5SWy7hMbw-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Pulvinar proin gravida hendrerit lectus a. At volutpat diam ut venenatis tellus in metus vulputate eu. Maecenas accumsan lacus vel facilisis volutpat. Enim eu turpis egestas pretium aenean pharetra magna. Orci eu lobortis elementum nibh tellus molestie nunc.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-educational",
        name: "Educational",
        articles: [
            {
                id: "4187d9c9-e176-4b0a-8bee-03f4f3be418a",
                class: "columns-3-balanced",
                header: "Business 101",
                image: {
                    src: "assets/images/austin-distel-rxpThOwuVgE-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Dictumst quisque sagittis purus sit amet.",
                type: "text",
                content:
                    "incidunt dui ut ornare lectus sit. Quis varius quam quisque id diam. Adipiscing diam donec adipiscing tristique risus nec feugiat in. Cursus sit amet dictum sit. Lacinia quis vel eros donec ac odio. Accumsan tortor posuere ac ut consequat semper. Interdum posuere lorem ipsum dolor sit amet consectetur adipiscing. Integer malesuada nunc vel risus commodo viverra. Arcu risus quis varius quam quisque id diam vel quam.\n\nEnim neque volutpat ac tincidunt vitae semper quis lectus nulla. Eget nulla facilisi etiam dignissim diam quis enim lobortis scelerisque. Sed tempus urna et pharetra pharetra massa.",
            },
            {
                id: "c519abd4-bb39-4b35-b3fb-130713f8f27b",
                class: "columns-3-balanced",
                header: "Startup",
                image: {
                    src: "assets/images/memento-media-XhYq-5KnxSk-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Posuere sollicitudin aliquam ultrices sagittis orci a.",
                type: "text",
                content:
                    "Potenti nullam ac tortor vitae purus faucibus. Vulputate mi sit amet mauris. Elit pellentesque habitant morbi tristique senectus. In pellentesque massa placerat duis ultricies. Cras fermentum odio eu feugiat pretium nibh ipsum. Ornare quam viverra orci sagittis eu. Commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend. Non diam phasellus vestibulum lorem sed risus. Metus vulputate eu scelerisque felis imperdiet.\n\nMagna ac placerat vestibulum lectus mauris. Lobortis feugiat vivamus at augue eget. Facilisis volutpat est velit egestas dui id ornare arcu odio.",
            },
            {
                id: "a7b41785-e2d9-4afa-a161-5edcffce77a8",
                class: "columns-3-balanced",
                header: "Make profit",
                image: {
                    src: "assets/images/austin-distel-97HfVpyNR1M-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Scelerisque fermentum dui faucibus in.",
                type: "text",
                content:
                    "Ornare aenean euismod elementum nisi quis. Tellus in hac habitasse platea dictumst vestibulum rhoncus est. Nisl nunc mi ipsum faucibus vitae aliquet nec. Eget egestas purus viverra accumsan in nisl nisi scelerisque. Urna duis convallis convallis tellus id interdum velit laoreet. Ultrices sagittis orci a scelerisque purus. Feugiat vivamus at augue eget. Ultricies tristique nulla aliquet enim. Nibh mauris cursus mattis molestie a iaculis at erat pellentesque.\n\nElementum eu facilisis sed odio morbi. Ac turpis egestas integer eget aliquet nibh praesent tristique magna. Tortor at risus viverra adipiscing at in tellus.",
            },
        ],
    },
    {
        id: "content-business-underscored",
        name: "Underscored",
        articles: [
            {
                id: "4e229873-04c6-410a-a433-18178fa4aad5",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "a623eb53-c205-4ba7-88cc-7d28a402fbe7",
                        image: {
                            src: "assets/images/bruce-mars-xj8qrWvuOEs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Scelerisque viverra mauris in aliquam sem fringilla ut morbi. Senectus et netus et malesuada fames ac turpis egestas. Et tortor at risus viverra. Iaculis nunc sed augue lacus viverra vitae congue. Nulla aliquet porttitor lacus luctus accumsan.",
                        url: "#",
                    },
                    {
                        id: "5a406442-2994-47c1-9e9c-51ccb2c12dbc",
                        image: {
                            src: "assets/images/ryan-plomp-TT6Hep-JzrU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Vitae justo eget magna fermentum. Vel eros donec ac odio tempor orci dapibus. Volutpat est velit egestas dui id ornare arcu odio. Est sit amet facilisis magna. Bibendum est ultricies integer quis auctor elit. Ullamcorper dignissim cras tincidunt lobortis feugiat vivamus.",
                        url: "#",
                    },
                ],
            },
            {
                id: "1760d2cf-9530-4c27-9943-ec0525b5dd4f",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "12d94ea1-157a-4f3d-87bf-28c305b52aea",
                        image: {
                            src: "assets/images/robert-bye-xHUZuSwVJg4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Scelerisque viverra mauris in aliquam sem fringilla ut morbi. Senectus et netus et malesuada fames ac turpis egestas. Et tortor at risus viverra. Iaculis nunc sed augue lacus viverra vitae congue. Nulla aliquet porttitor lacus luctus accumsan.",
                        url: "#",
                    },
                    {
                        id: "8f623500-fbd4-4bc0-9a72-31b7c18749a8",
                        image: {
                            src: "assets/images/jay-clark-P3sLerH3UmM-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Vitae justo eget magna fermentum. Vel eros donec ac odio tempor orci dapibus. Volutpat est velit egestas dui id ornare arcu odio. Est sit amet facilisis magna. Bibendum est ultricies integer quis auctor elit. Ullamcorper dignissim cras tincidunt lobortis feugiat vivamus.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-investing-101",
        name: "Investing 101",
        articles: [
            {
                id: "d3b35a69-8fa6-49b6-a86f-a451e15430f0",
                class: "columns-3-balanced",
                header: "Manage your assets",
                type: "articles-list",
                content: [
                    {
                        id: "d7e4b0d6-79f6-4ee0-9a25-07948eb0f199",
                        title: "Ic turpis egestas maecenas pharetra convallis. Dui accumsan sit amet nulla facilisi morbi tempus.",
                        content:
                            "A scelerisque purus semper eget duis at. Condimentum lacinia quis vel eros donec ac odio. Pretium fusce id velit ut tortor pretium viverra suspendisse. Blandit aliquam etiam erat velit scelerisque in. Est placerat in egestas erat imperdiet sed euismod nisi. Suspendisse potenti nullam ac tortor vitae purus faucibus.",
                    },
                    {
                        id: "e1c56eba-491c-461f-85dd-a3df520dfbfc",
                        title: "Risus commodo viverra maecenas accumsan lacus vel.",
                        content:
                            "Est ullamcorper eget nulla facilisi etiam dignissim diam quis enim. Iaculis eu non diam phasellus. Odio aenean sed adipiscing diam donec. Eleifend donec pretium vulputate sapien nec sagittis aliquam malesuada bibendum.",
                    },
                    {
                        id: "3b46da4b-dd8e-49fd-b53f-64effe759dea",
                        title: "Vitae ultricies leo integer malesuada nunc vel risus commodo.",
                        content:
                            "Donec et odio pellentesque diam volutpat. Sed libero enim sed faucibus turpis in eu. Aliquam nulla facilisi cras fermentum odio eu feugiat pretium. Tristique risus nec feugiat in fermentum. Turpis egestas maecenas pharetra convallis posuere morbi leo urna.",
                    },
                ],
            },
            {
                id: "27a697e9-74a9-459c-9cd2-d479d65ac2f7",
                class: "columns-3-balanced",
                header: "What to watch",
                type: "articles-list",
                content: [
                    {
                        id: "c1d78742-406a-4123-86cd-bc4fad85f28b",
                        title: "Elementum integer enim neque volutpat.",
                        content:
                            "Dignissim diam quis enim lobortis scelerisque. Lacus vestibulum sed arcu non odio euismod lacinia at quis. Mi bibendum neque egestas congue quisque. Arcu dui vivamus arcu felis bibendum ut tristique. Consectetur adipiscing elit ut aliquam purus sit amet luctus venenatis.",
                    },
                    {
                        id: "01ca72c3-7112-4a57-9173-a527977755ae",
                        title: "Vitae turpis massa sed elementum tempus egestas sed.",
                        content:
                            "Eu lobortis elementum nibh tellus molestie. Egestas congue quisque egestas diam in arcu cursus euismod quis. Purus non enim praesent elementum facilisis. Suscipit tellus mauris a diam maecenas sed enim ut sem. Sed elementum tempus egestas sed sed risus pretium quam.",
                    },
                    {
                        id: "7734f54b-5b1b-4a6f-b81a-b15b0f0d52cb",
                        title: "Consequat ac felis donec et odio pellentesque diam.",
                        content:
                            "Pharetra diam sit amet nisl suscipit adipiscing bibendum. Mi eget mauris pharetra et ultrices neque ornare. Habitant morbi tristique senectus et netus et. Quis eleifend quam adipiscing vitae. Fames ac turpis egestas maecenas pharetra convallis posuere morbi.",
                    },
                ],
            },
            {
                id: "cff3dc12-6773-4f70-a22d-ff1bc100c818",
                class: "columns-3-balanced",
                header: "Did you know?",
                type: "articles-list",
                content: [
                    {
                        id: "379fa367-cf87-4b0a-8ab6-1a0b1a8d7943",
                        title: "Lacus sed viverra tellus in. Eget mi proin sed libero enim sed.",
                        content:
                            "A diam maecenas sed enim. Platea dictumst vestibulum rhoncus est pellentesque elit. Metus dictum at tempor commodo ullamcorper. Est ullamcorper eget nulla facilisi etiam dignissim diam. Felis eget velit aliquet sagittis id consectetur purus.",
                    },
                    {
                        id: "508c1266-d70f-4e9d-ae5f-fab87fccc1a0",
                        title: "Est lorem ipsum dolor sit amet. Duis ultricies lacus sed turpis tincidunt.",
                        content:
                            "Mattis pellentesque id nibh tortor id aliquet lectus. Odio aenean sed adipiscing diam donec adipiscing. Mi in nulla posuere sollicitudin aliquam ultrices sagittis. Dictum varius duis at consectetur lorem donec massa sapien faucibus.",
                    },
                    {
                        id: "b3fa7b41-ed86-4ab1-a86a-21283741d1a0",
                        title: "Duis ut diam quam nulla porttitor massa id.",
                        content:
                            "Id aliquet lectus proin nibh nisl condimentum id venenatis. Ultrices in iaculis nunc sed augue lacus viverra vitae congue. Lectus urna duis convallis convallis tellus id interdum velit. Duis convallis convallis tellus id interdum. Et malesuada fames ac turpis egestas sed.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-stock-market",
        name: "Stock market",
        articles: [
            {
                id: "49e01dcc-39fd-482d-b0c1-31918f791041",
                class: "columns-wrap",
                header: "Dow Jones",
                type: "excerpt",
                content: [
                    {
                        id: "a9ae906b-e98d-412d-89a1-baba39c0be01",
                        image: {
                            src: "assets/images/annie-spratt-IT6aov1ScW0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Pretium fusce id velit ut tortor pretium viverra suspendisse potenti. Nisi scelerisque eu ultrices vitae auctor eu. Amet massa vitae tortor condimentum lacinia quis vel. In arcu cursus euismod quis.",
                    },
                    {
                        id: "217c58fc-0edf-417d-9305-4abc0615eef8",
                        image: {
                            src: "assets/images/tech-daily-vxTWpu14zeM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Tempus urna et pharetra pharetra massa massa ultricies mi. Vestibulum lorem sed risus ultricies tristique nulla aliquet enim. Sit amet luctus venenatis lectus magna fringilla urna.",
                    },
                    {
                        id: "82606dff-6bc4-4b84-b0d8-c7557f6482e4",
                        image: {
                            src: "assets/images/markus-spiske-jgOkEjVw-KM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Viverra adipiscing at in tellus integer feugiat scelerisque varius morbi. Massa tempor nec feugiat nisl pretium fusce id. Elit ut aliquam purus sit amet luctus.",
                    },
                ],
            },
            {
                id: "084674ba-b34b-4841-8674-e29bfd3633fa",
                class: "columns-wrap",
                header: "S&P 500",
                type: "excerpt",
                content: [
                    {
                        id: "2c06041f-b0b4-47f3-a1c4-ab3fb25f0803",
                        image: {
                            src: "assets/images/boris-stefanik-q49CgyIrLes-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Risus quis varius quam quisque id diam vel quam. Risus at ultrices mi tempus imperdiet nulla malesuada. Aliquet enim tortor at auctor urna. Sapien et ligula ullamcorper malesuada proin libero. Nunc sed augue lacus viverra vitae congue.",
                    },
                    {
                        id: "b408a578-0fda-4423-9635-cbf1c2aa675d",
                        image: {
                            src: "assets/images/m-ZzOa5G8hSPI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Quisque id diam vel quam elementum pulvinar etiam non. Lacus laoreet non curabitur gravida arcu ac tortor dignissim convallis. Ac ut consequat semper viverra nam libero justo.",
                    },
                    {
                        id: "635b4368-112d-4062-8e8c-e95171cffa6f",
                        image: {
                            src: "assets/images/matthew-henry-0Ol8Sa2n21c-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Pulvinar etiam non quam lacus suspendisse faucibus interdum posuere lorem. Enim facilisis gravida neque convallis. Quis blandit turpis cursus in hac habitasse platea.",
                    },
                ],
            },
            {
                id: "d287a7b5-305f-4e6f-81c7-3a6f1e833a5a",
                class: "columns-wrap",
                header: "Day Trading",
                type: "excerpt",
                content: [
                    {
                        id: "5a5482c2-f4ef-4cca-98b4-1e6cdca39ec5",
                        image: {
                            src: "assets/images/dylan-calluy-j9q18vvHitg-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Pellentesque pulvinar pellentesque habitant morbi tristique senectus et netus et. Sed enim ut sem viverra aliquet eget. Porttitor lacus luctus accumsan tortor. Sit amet justo donec enim diam.",
                    },
                    {
                        id: "f6fa61d0-5086-445c-8192-9f78ce2c3a63",
                        image: {
                            src: "assets/images/yucel-moran-4ndj0pATzeM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nibh sit amet commodo nulla facilisi nullam vehicula. Lectus mauris ultrices eros in cursus turpis massa. Egestas fringilla phasellus faucibus scelerisque eleifend donec pretium. Sed adipiscing diam donec adipiscing tristique risus nec feugiat in.",
                    },
                    {
                        id: "f3f5f6b2-cdcf-49b6-b650-bb80c9459dde",
                        image: {
                            src: "assets/images/stefan-stefancik-pzA7QWNCIYg-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Consectetur lorem donec massa sapien faucibus. Aliquet porttitor lacus luctus accumsan tortor. Pharetra pharetra massa massa ultricies mi. Aliquam id diam maecenas ultricies mi eget mauris pharetra. Rhoncus urna neque viverra justo nec ultrices dui sapien eget.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-impact",
        name: "Impact",
        articles: [
            {
                id: "f87f6f06-2480-48b1-abf0-17c97fa92d27",
                class: "columns-3-balanced",
                header: "Oil crisis",
                type: "articles-list",
                content: [
                    {
                        id: "f452479c-6084-4b57-925d-a7851a0a1211",
                        title: "Eleifend donec pretium vulputate sapien nec sagittis.",
                        content:
                            "Adipiscing bibendum est ultricies integer quis. Viverra ipsum nunc aliquet bibendum enim facilisis gravida neque. Suspendisse in est ante in. Semper auctor neque vitae tempus quam pellentesque. Et tortor at risus viverra adipiscing at in tellus integer.",
                    },
                    {
                        id: "1caebfb3-912b-485d-a4b7-4500adb5066a",
                        title: "Ornare aenean euismod elementum nisi quis eleifend quam.",
                        content:
                            "Pretium aenean pharetra magna ac. Sem nulla pharetra diam sit amet nisl suscipit adipiscing bibendum. Neque vitae tempus quam pellentesque nec nam aliquam sem. Potenti nullam ac tortor vitae purus faucibus ornare suspendisse. Ipsum nunc aliquet bibendum enim facilisis gravida neque.",
                    },
                    {
                        id: "341d9b4b-d3eb-4728-922e-222d745665c1",
                        title: "Ultrices sagittis orci a scelerisque purus semper. Porttitor massa id neque aliquam vestibulum morbi blandit.",
                        content:
                            "Augue eget arcu dictum varius. Aliquet nibh praesent tristique magna sit amet purus gravida. Mattis enim ut tellus elementum. A diam sollicitudin tempor id eu nisl nunc mi. Justo nec ultrices dui sapien eget mi proin. Euismod lacinia at quis risus sed vulputate odio.",
                    },
                ],
            },
            {
                id: "8d0c8045-a260-47ec-9f28-1098d994da86",
                class: "columns-3-balanced",
                header: "Tech Markets",
                type: "articles-list",
                content: [
                    {
                        id: "40e13034-8351-4f8a-8e1d-3d6f068e6709",
                        title: "Dictum sit amet justo donec. Justo donec enim diam vulputate ut pharetra sit.",
                        content:
                            "Bibendum enim facilisis gravida neque. Ullamcorper dignissim cras tincidunt lobortis feugiat vivamus at augue. Auctor neque vitae tempus quam pellentesque nec. Justo donec enim diam vulputate ut pharetra sit amet. Aliquam sem fringilla ut morbi tincidunt augue interdum velit.",
                    },
                    {
                        id: "2b763d78-1424-4a2e-a5a2-79fe02253600",
                        title: "Massa massa ultricies mi quis hendrerit dolor magna eget.",
                        content:
                            "Ornare massa eget egestas purus viverra accumsan in nisl nisi. A arcu cursus vitae congue mauris rhoncus. Gravida arcu ac tortor dignissim convallis aenean et tortor. Elit scelerisque mauris pellentesque pulvinar pellentesque habitant. Volutpat diam ut venenatis tellus in metus.",
                    },
                    {
                        id: "3d29bcd8-9d18-4dac-8f98-197c968f90bd",
                        title: "Duis at consectetur lorem donec massa sapien faucibus.",
                        content:
                            "acilisis gravida neque convallis a cras semper auctor neque. Non nisi est sit amet facilisis magna etiam tempor. Posuere morbi leo urna molestie at elementum eu. Tellus in hac habitasse platea dictumst vestibulum rhoncus est pellentesque.",
                    },
                ],
            },
            {
                id: "9144e1b3-46b1-4c71-b26d-6f4cf74e7444",
                class: "columns-3-balanced",
                header: "Declining Markets",
                type: "articles-list",
                content: [
                    {
                        id: "4887a57f-dee5-4023-a173-bcb2a691f6ca",
                        title: "Odio aenean sed adipiscing diam donec adipiscing tristique risus nec.",
                        content: "Pharetra vel turpis nunc eget. Non arcu risus quis varius quam quisque id. Augue ut lectus arcu bibendum at varius vel pharetra vel. Rhoncus dolor purus non enim praesent elementum.",
                    },
                    {
                        id: "73bd8127-50e4-44e7-836d-07e330226717",
                        title: "Quis enim lobortis scelerisque fermentum. Nisl rhoncus mattis rhoncus urna. Felis eget velit aliquet sagittis id consectetur purus ut.",
                        content:
                            "Enim nec dui nunc mattis enim ut. Amet luctus venenatis lectus magna fringilla urna porttitor rhoncus dolor. Sed vulputate mi sit amet mauris commodo. Ultricies lacus sed turpis tincidunt id aliquet risus feugiat. In hac habitasse platea dictumst vestibulum rhoncus est.",
                    },
                    {
                        id: "a585ea07-caf5-44b9-88d2-f8f5f8ae6f02",
                        title: "landit cursus risus at ultrices mi tempus imperdiet nulla malesuada.",
                        content:
                            "Vitae justo eget magna fermentum iaculis eu non diam phasellus. Et netus et malesuada fames ac turpis. In eu mi bibendum neque egestas congue. Justo eget magna fermentum iaculis eu non diam. Feugiat nibh sed pulvinar proin gravida hendrerit lectus a.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "1e60235c-0198-4448-9267-f3f86542d7dc",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "7498eaec-d8dc-442f-b939-2bff86ed2c6e",
                        image: {
                            src: "assets/images/alice-pasqual-Olki5QpHxts-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "In massa tempor nec feugiat nisl. Mattis vulputate enim nulla aliquet porttitor lacus luctus. Et sollicitudin ac orci phasellus egestas tellus rutrum tellus pellentesque. Nec sagittis aliquam malesuada bibendum.",
                        url: "#",
                    },
                    {
                        id: "cce7d8eb-b0d7-40a6-bc7d-932ac420fd43",
                        image: {
                            src: "assets/images/lukasz-radziejewski-cg4MzL_eSvU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Euismod quis viverra nibh cras pulvinar mattis nunc. Mauris pellentesque pulvinar pellentesque habitant morbi tristique senectus. Malesuada bibendum arcu vitae elementum curabitur vitae. Fusce id velit ut tortor.",
                        url: "#",
                    },
                ],
            },
            {
                id: "46e89da3-b39c-43a7-9178-efeeb91e973d",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "40389294-8c93-4c5a-8a63-57ffefdd8f89",
                        image: {
                            src: "assets/images/microsoft-365-f1zQuagWCTA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Scelerisque felis imperdiet proin fermentum leo vel orci. Tortor vitae purus faucibus ornare suspendisse sed nisi. Molestie at elementum eu facilisis sed odio. Pellentesque sit amet porttitor eget. Vitae auctor eu augue ut lectus arcu bibendum at varius.",
                        url: "#",
                    },
                    {
                        id: "bb50d294-0aaa-40c1-aebd-f727bc270b17",
                        image: {
                            src: "assets/images/emran-yousof-k8ZbMQWbx34-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Egestas sed sed risus pretium quam vulputate dignissim suspendisse. Potenti nullam ac tortor vitae purus faucibus ornare. Nunc mattis enim ut tellus elementum sagittis vitae et leo. Pellentesque pulvinar pellentesque habitant morbi tristique senectus.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "d6c99f00-e45b-4da3-abb8-2a0a3bd27cc7",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d9326d57-6280-4f00-a047-12be65eb3ca2",
                        image: {
                            src: "assets/images/junko-nakase-Q-72wa9-7Dg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Facilisis magna etiam tempor orci eu lobortis elementum nibh tellus. Morbi enim nunc faucibus a pellentesque sit amet porttitor eget.",
                    },
                    {
                        id: "bbe374d2-6058-4800-8ecb-2101785ba463",
                        image: {
                            src: "assets/images/heather-ford-5gkYsrH_ebY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Cursus vitae congue mauris rhoncus aenean vel elit. Ultrices neque ornare aenean euismod elementum nisi. Aliquet risus feugiat in ante metus dictum at tempor commodo.",
                    },
                ],
            },
            {
                id: "2b905eee-c666-4704-9658-1e0757b02253",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "e84ec76b-e0ec-4477-adcd-3a7f49516895",
                        image: {
                            src: "assets/images/metin-ozer-hShrr0WvrQs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Sit amet aliquam id diam maecenas ultricies. Magna sit amet purus gravida quis blandit. Risus nullam eget felis eget nunc. Ac felis donec et odio pellentesque diam volutpat commodo sed.",
                    },
                    {
                        id: "f5cddda2-e658-4f4f-b245-33228dad3eb3",
                        image: {
                            src: "assets/images/mac-blades-jpgJSBQtw5U-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Purus faucibus ornare suspendisse sed nisi lacus. Malesuada nunc vel risus commodo. Pretium fusce id velit ut tortor pretium viverra suspendisse potenti.",
                    },
                ],
            },
            {
                id: "1acc8fc3-74bb-46b0-8d67-bee9bfb7667a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "41f2e683-c165-4573-a50d-27aad4deae11",
                        image: {
                            src: "assets/images/keagan-henman-xPJYL0l5Ii8-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Aliquam malesuada bibendum arcu vitae elementum curabitur. A pellentesque sit amet porttitor eget dolor morbi non.",
                    },
                    {
                        id: "8249c70b-245f-44e4-829e-d08a273522c7",
                        image: {
                            src: "assets/images/erik-mclean-ByjIzFupcHo-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Tortor at auctor urna nunc id cursus metus aliquam. Facilisis magna etiam tempor orci. Eu nisl nunc mi ipsum faucibus vitae aliquet.",
                    },
                ],
            },
            {
                id: "a005c941-9e4b-4219-88df-d6a553b3c237",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1d5eee05-b406-4853-b5ba-f37728062b2e",
                        image: {
                            src: "assets/images/ixography-05Q_XPF_YKs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Cursus mattis molestie a iaculis at. Nullam eget felis eget nunc. Tortor id aliquet lectus proin nibh nisl condimentum id.",
                    },
                    {
                        id: "66f72ca0-97b1-48f1-9aa5-ad53f4d040d5",
                        image: {
                            src: "assets/images/harley-davidson-fFbUdx80oCc-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "arius morbi enim nunc faucibus a pellentesque sit amet porttitor. Blandit libero volutpat sed cras. Sed viverra ipsum nunc aliquet bibendum.",
                    },
                ],
            },
        ],
    },
];
